import { Component, OnInit } from '@angular/core';
import { LeadsService } from '../../../../../core/services/leads.service';
import { LeadStatusType } from '../../../../../data/models';
import { RepoSettingsService } from '../../../../../data/repositories/repo-settings.service';

@Component({
    selector: 'app-sidebar2-leads-sub-menu',
    templateUrl: './sidebar2-leads-sub-menu.component.html',
    standalone: false,
})
export class Sidebar2LeadsSubMenuComponent implements OnInit {
    // @ts-ignore TS2564
    statuses: LeadStatusType[];
    disableFilter = false;
    // @ts-ignore TS2564
    total: number;
    allChecked = true;
    dropdownOpen: any = true;
    settingsProperty = 'NavigationV2LeadsStatusSelections';
    constructor(
        public leadsService: LeadsService,
        public settings: RepoSettingsService
    ) {}

    ngOnInit() {
        this.getUserLeadsStatuses();
        this.leadsService.$leadsFilterDisabled.subscribe((val) => {
            this.disableFilter = val;
        });
    }

    getUserLeadsStatuses() {
        this.leadsService.getStatusQuantities().subscribe((res) => {
            this.statuses = res.data.leadStatusesWithCount;
            this.setStatus();
        });
    }

    updateFilterStatus() {
        this.leadsService.getLeadsFilterStatus();
    }

    setStatus() {
        this.total = 0;
        // @ts-ignore TS7052
        const storedUserLeadsStatus = this.settings[this.settingsProperty] ? JSON.parse(this.settings[this.settingsProperty]) : [];
        this.total = 0;
        if (storedUserLeadsStatus.length > 0) {
            this.statuses.forEach((i) => {
                this.total += i.count;
                i['selected'] = storedUserLeadsStatus.indexOf(i.status) !== -1;
            });
            this.allChecked = storedUserLeadsStatus.indexOf('All') !== -1;
        } else {
            this.statuses.forEach((i) => {
                this.total += i.count;
                i['selected'] = true;
            });
            this.allChecked = true;
        }
    }

    // @ts-ignore TS7006
    toggleAll(evt) {
        this.allChecked = evt.target.checked;
        this._toggleAll(evt, this.settingsProperty, this.statuses);
        // Now update the service to redraw the list filtering by status
        this.leadsService.getLeadsFilterStatus();
    }

    // @ts-ignore TS7006
    toggleSelection(evt) {
        this._toggleSelection(evt, this.settingsProperty, this.statuses);
        if (!evt.target.checked) {
            this.allChecked = false;
        }
        // Now update the service to redraw the list filtering by status
        this.leadsService.getLeadsFilterStatus();
    }

    // @ts-ignore TS7006
    _toggleSelection(evt, setting, statuses) {
        const checked: boolean = evt.target.checked;
        // @ts-ignore TS7052
        const storedUserLeadsStatus: any = JSON.parse(this.settings[setting]);
        // @ts-ignore TS7006
        const statusIndex: number = statuses.findIndex((item) => {
            return item.status === evt.target.value;
        });
        statuses[statusIndex]['selected'] = checked;

        // Toggle All to off when we adjust any of the items
        if (!checked) {
            if (storedUserLeadsStatus[0] === 'All') {
                storedUserLeadsStatus.splice(0, 1);
            }
        }

        const selectionIndex: number = storedUserLeadsStatus.indexOf(evt.target.value);
        if (selectionIndex !== -1) {
            storedUserLeadsStatus.splice(selectionIndex, 1);
        } else {
            storedUserLeadsStatus.push(evt.target.value);
        }

        // @ts-ignore TS7052
        this.settings[setting] = JSON.stringify(storedUserLeadsStatus);
    }

    // @ts-ignore TS7006
    _toggleAll(evt, setting, statuses) {
        const storedUserLeadsStatus = [];
        // Toggle all if we selected that.
        if (evt.target.checked) {
            // @ts-ignore TS7006
            statuses.forEach((i) => {
                i.selected = true;
                storedUserLeadsStatus.push(i.status);
            });
            storedUserLeadsStatus.unshift('All');
        } else {
            // @ts-ignore TS7006
            statuses.forEach((i) => {
                i.selected = false;
            });
        }

        // @ts-ignore TS7052
        this.settings[setting] = JSON.stringify(storedUserLeadsStatus);
    }
}
